module.exports = __webpack_public_path__ + "media/auth/vid/sidebar-vid-a4183883c91694925674b1dc444fc3ba.mp4";